import React from 'react';
import {loader} from './Spinner.css';

const spinner = () => (
    <div className="container-loader">
        <div className="loader">Loading...</div>
    </div>
);

export default spinner;